exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logs-table[data-v-79f35aa9] {\n  max-height: 26.5rem;\n  overflow-y: scroll;\n  border-radius: 0 0 10px 10px;\n}\n[data-v-79f35aa9]::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 7px;\n}\n[data-v-79f35aa9]::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79f35aa9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/audits/Trail.vue
// module id = 1269
// module chunks = 2